import { createAction } from 'redux-actions'

export const getHappyPathInfoStart = createAction('GET_HAPPY_PATH_INFO_START')
export const getHappyPathInfoSuccess = createAction(
  'GET_HAPPY_PATH_INFO_SUCCESS'
)
export const getHappyPathInfoFail = createAction('GET_HAPPY_PATH_INFO_FAIL')
export const hideHpModal = createAction('HIDE_HP_MODAL')
